<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteAssignmentDialog"
    :title="t('assignments.deleteDialog.title')"
    :confirm-text="t('assignments.deleteDialog.confirm')"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>
        {{ t('assignments.deleteDialog.confirmMessage1') }}
        <strong>{{ assignmentTitle }}</strong>؟
      </p>
      <p class="text-danger">{{ t('assignments.deleteDialog.confirmMessage2') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseDialog from '@/components/common/BaseDialog.vue';

const { t } = useI18n();

const baseDialog = ref(null);
const assignmentTitle = ref('');
const assignmentId = ref(null);

const open = (assignment) => {
  assignmentTitle.value = assignment.title;
  assignmentId.value = assignment.id;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = () => {
  emit('delete', assignmentId.value);
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
